import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { Promotion } from './promotion.model';

export class PromotionsDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return Promotion.fromDto(dto) as any;
  }
}
